import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslate, useTranslate } from 'core/translate';
import { useParams } from 'react-router-dom';
import FullPageCompareHeader from '../../components/compareManager/fullPageCompareHeading/FullPageCompareHeader';
import { withModelInfo } from '../../common/ModelInfoContext';
import { useNavigate } from 'react-router-dom';
import LoadingSpecsCompare from '../../common/loading/LoadingSpecsCompare';
import BodyCompare from '../../steps/config/body/bodyCompareModal/BodyCompare';
import { fetchConfig } from '../../api/fetchConfig';
import fetchFeatures from '../../api/fetchFeatures';
import { fetchTrimMatrixWithModelInfo } from '../../api/fetchTrimMatrix';
import useCompareScrolling from '../compareManager/useCompareScrolling';
import fetchCapabilities from '../../api/fetchCapabilities';

const BodyComparePage = ({ params, modelInfo, appResources }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [config, setConfig] = useState();
  const [features, setFeatures] = useState();
  const [trimMatrix, setTrimMatrix] = useState();
  const [capabilities, setCapabilities] = useState();

  const { postalCode } = params;

  const navigate = useNavigate();
  const translate = useTranslate();

  const { bodyStyleTitle } = appResources;
  const title = translate('compare.specs.title.v3', {
    title: bodyStyleTitle,
  });

  const { id } = useParams();

  const analyticsKey = 'body compare';

  const [scrolling] = useCompareScrolling();

  const onClose = (e) => {
    e?.preventDefault();
    window?.history?.length > 1
      ? navigate(-1)
      : (document.location = location.origin);
  };

  const onSelect = () => {};

  const fetchData = () => {
    Promise.all([
      fetchConfig({
        postalCode,
      }),
      fetchFeatures(modelInfo),
      fetchTrimMatrixWithModelInfo(modelInfo, postalCode),
      fetchCapabilities(modelInfo),
    ])
      .then(([config, features, trimMatrix, capabilities]) => {
        setConfig(config);
        setFeatures(features);
        setTrimMatrix(trimMatrix);
        setIsLoaded(true);
        setCapabilities(capabilities);
      })
      .catch();
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="compare__nav-padding">
      {isLoaded ? (
        <>
          <FullPageCompareHeader
            analyticsKey={analyticsKey}
            title={title}
            onClose={onClose}
          />
          <BodyCompare
            config={config}
            trimMatrix={trimMatrix}
            features={features}
            onClose={onClose}
            appResources={appResources}
            selectedBodyTypeId={+(id || 1)}
            analyticsKey={analyticsKey}
            onSelect={onSelect}
            isFeatures={true}
            isScrolled={scrolling}
            capabilities={capabilities}
          />
        </>
      ) : (
        <LoadingSpecsCompare />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { appResources, params } = state;
  return {
    params,
    appResources,
  };
};

export default withModelInfo(
  connect(mapStateToProps)(withTranslate(BodyComparePage))
);
